import { REACT_APP_ENVIRONMENT } from "shared/config";

export const isDevelopmentEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT === "development";
};

export const isTestEnvironment = () => {
  return REACT_APP_ENVIRONMENT === "development";
};
